import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabella-causali-rifiuti',
  templateUrl: './tabella-causali-rifiuti.component.html',
  styleUrls: ['./tabella-causali-rifiuti.component.css']
})
export class TabellaCausaliRifiutiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  validateDataFieldPrepared(e:any){
    console.log("In prepared ",e);
  }
  AllEvent(e:any){
   console.log(e); 
//onInitNewRow
if(e.name=="valueChangedList"){
  console.log(e.name);
}
    if(e.name=="onSaving"){
      //let valueCer=e.changes[0].codiceCER;
      //console.log("in all events ",valueCer);

    }
    //
  }
}
